import { combineReducers } from 'redux';

export function activateError(state = null, action) {
  switch (action.type) {
    case 'COMPANY_USER_ACTIVATE_ERROR':
      return action.activateError;

    case 'COMPANY_USER_ACTIVATE_RESET':
      return null;

    default:
      return state;
  }
}

export function activateLoading(state = false, action) {
  switch (action.type) {
    case 'COMPANY_USER_ACTIVATE_LOADING':
      return action.activateLoading;

    case 'COMPANY_USER_ACTIVATE_RESET':
      return false;

    default:
      return state;
  }
}

export function activated(state = null, action) {
  switch (action.type) {
    case 'COMPANY_USER_ACTIVATE_SUCCESS':
      return action.activated;

    case 'COMPANY_USER_ACTIVATE_RESET':
      return null;

    default:
      return state;
  }
}


export default combineReducers({
  activateError,
  activateLoading,
  activated,
});
